export var version = "3.10.6";
//# sourceMappingURL=version.js.map